import { Logout as LogoutIcon } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import React from "react";

interface LogoutConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
          minWidth: "500px",
          margin: "16px",
        },
      }}
    >
      <DialogTitle>
        <Box className="flex items-center gap-3">
          <Box
            className="w-10 h-10 rounded-full flex items-center justify-center"
            sx={{
              backgroundColor: "#FEF2F2",
              color: "#DC2626",
            }}
          >
            <LogoutIcon />
          </Box>
          <Typography variant="h6" className="font-semibold">
            Confirm Logout
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" className="text-gray-600">
          Are you sure you want to logout? You will need to sign in again to
          access your account.
        </Typography>
      </DialogContent>

      <DialogActions
        className="gap-2 p-4"
        sx={{
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isLoading}
          className="px-6 py-2"
          sx={{
            borderColor: "#D1D5DB",
            color: "#374151",
            "&:hover": {
              borderColor: "#9CA3AF",
              backgroundColor: "#F9FAFB",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isLoading}
          className="px-6 py-2"
          startIcon={<LogoutIcon />}
          sx={{
            backgroundColor: "#DC2626",
            "&:hover": {
              backgroundColor: "#B91C1C",
            },
            "&:disabled": {
              backgroundColor: "#FCA5A5",
            },
          }}
        >
          {isLoading ? "Logging out..." : "Logout"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmationModal;
